const breakpoints = {
  sm: '375px',
  md: '768px',
  xlg: '1025px',
  lg: '1024px',
  '2lg': '1200px',
  '3lg': '1225px',
  xl: '1366px',
  '2xl': '3000px',
};

export default breakpoints;
